import * as yup from 'yup'

import { EVENT_FORM_CONTEXT_IS_EUO } from './formContext'

import { attendeesFieldSchema } from '@/components/Event/NewScript/schemas/attendeeSchema'
import { ScriptAttendee } from '@/types'

export const transcriptOrderFields = {
  order_transcript: yup
    .boolean()
    .nullable()
    .default(null)
    .when(`$${EVENT_FORM_CONTEXT_IS_EUO}`, ([isEUO], schema) => {
      if (isEUO) {
        return schema
      }

      return schema.test(
        'transcript-order-validation',
        'If this field is set to "Yes", at least one attendee needs to order certified transcript',
        function (value) {
          const attendees: ScriptAttendee[] = this.parent.attendees

          if (value) {
            return attendees.some(
              attendee => attendee.transcript_order !== null,
            )
          }

          return true
        },
      )
    }),
  attendees: attendeesFieldSchema,
}
